// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  toggleUiBooleanSetting,
  getUiSetting,
} from '../../../../store/uiStore';
import {
  ActiveBundle,
  ActiveClaimFree,
  ActiveColor,
  ActiveDuration,
  ActiveAccessory,
  ActiveExtraContract,
  ActiveMileage,
  ActivePackage,
} from './atoms';
import Group from '../group';
import GroupTitle from '../groupTitle';
import type { CartGroupItem } from '../../../../store/configuration/types';

type OwnProps = {|
  index: string,
  title: string,
  price: number,
  items: Array<CartGroupItem>,
  id: string,
|};

type StateProps = {|
  isGroupOpen: Function,
|};

type DispatchProps = {|
  toggleCartGroup: Function,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const componentMap = {
  bundles: ActiveBundle,
  claim_free: ActiveClaimFree,
  colors: ActiveColor,
  durations: ActiveDuration,
  mileages: ActiveMileage,
  packages: ActivePackage,
  extras: ActiveAccessory,
  insurances: ActiveExtraContract,
};

const showCount = id => ['extras'].includes(id);

const CartGroup = ({
  title,
  price,
  items,
  index,
  isGroupOpen,
  toggleCartGroup,
  id,
}: Props) => (
  <Group>
    <GroupTitle
      collapsible
      title={title}
      price={price}
      count={items && items.length}
      onClick={() => toggleCartGroup(index)}
      isOpen={isGroupOpen(index)}
      showCount={showCount(id)}
    />
    {items && items.map((item, itemIndex) => {
      const Component = componentMap[item.type];

      if (!Component) {
        return null;
      }

      return (
        <Component
          active={item.active}
          key={`${item.type}-${itemIndex}`}  // eslint-disable-line
          price={item.price}
          show={isGroupOpen(index)}
        />
      );
    })}
  </Group>
);

const mapStateToProps = (state): StateProps => ({
  isGroupOpen: (index: string) => getUiSetting(state, index),
});

const mapDispatchToProps = (dispatch: Function, ownProps: OwnProps): DispatchProps => ({
  toggleCartGroup: () => dispatch(toggleUiBooleanSetting(ownProps.index)),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(CartGroup);
